import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { fetchConToken } from '../../api/fetch';
import { FaEthernet } from 'react-icons/fa';
import CheckPon from './CheckPon';

const ModOlts = ({ show, onHide, dialogClassName, size, scrollable, olt, olports }) => {
    const [puertos, setPuertos] = useState([]);

    useEffect(() => {
        if (show) getPorts();
    }, [show]);
    const getPorts = async () => {
        const r = await fetchConToken(`fibra/pons/${olt.id}`);
        if (r.ok) setPuertos(r.data);
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName={dialogClassName} size={size} scrollable={scrollable}>
            <Modal.Header onHide={onHide} closeButton>
                <h4 className="modal-title">Información OLT</h4>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Row>
                        <Col>
                            <div className="d-flex flex-row  align-items-center justify-content-center">
                                <i className="mdi mdi-checkbox-marked-circle mdi-18px text-success" />
                                <h4>Estado de puertos</h4>
                            </div>
                        </Col>
                        <Row>
                            {puertos.map((pr, i) => (
                                <Col key={`${i}-ether`}>
                                    <FaEthernet className={`fs-2 ${pr.status ? 'text-success' : 'text-danger'} `} />

                                    <div className="d-flex flex-row  align-items-center justify-content-center">
                                        {pr.nombre.includes('PON') && olports && (
                                            <CheckPon id={pr.id} enable={pr.enable} />
                                        )}
                                        <span className="">{pr.nombre}</span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Row>

                    <Row>
                        <Col className="bg-light p-2">INFORMACIÓN</Col>
                    </Row>
                    <Row>
                        <Col className="bg-light bg-gradient p-2">Nombre</Col> <Col className="p-2">{olt?.nombre}</Col>
                    </Row>
                    <Row>
                        <Col className="bg-light bg-gradient p-2">Temperatura</Col>{' '}
                        <Col className="p-2">
                            {olt?.tem} <i className="mdi mdi-thermometer" />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="bg-light bg-gradient p-2">Modelo</Col> <Col className="p-2">{olt?.modelo}</Col>
                    </Row>
                    <Row>
                        <Col className="bg-light bg-gradient p-2">Onus en Olt</Col>{' '}
                        <Col className="p-2">
                            {' '}
                            <span className="badge rounded-pill bg-primary p-1">{olt?.total}</span>
                        </Col>
                        <Col className="bg-light bg-gradient p-2">Onus ONLINE</Col>{' '}
                        <Col className="p-2">
                            <span className="badge rounded-pill bg-success p-1 fw-bolder">{olt?.online}</span>
                        </Col>
                        <Col className="bg-light bg-gradient p-2 border-top ">Onus OFFLINE</Col>{' '}
                        <Col className="p-2">
                            <span className="badge rounded-pill bg-danger p-1">{olt?.offline}</span>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default ModOlts;
